import axios from "axios";

const win: any = window;

let config = {
    api: {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            channel: 'PORTAL',
            referenceId: 'SR_123hg87asfafF32'
        },
    },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();

api.defaults.validateStatus = function () {
    return true;
};

api.interceptors.request.use(
    async (conf: any) => {
        const token = window.location.origin.includes('localhost') ? '0c9a0fbb-5cf7-4bb0-a952-bc1805e98922' : win["dapiClientToken"];

        conf.baseURL = win["base_api_url"];
        conf.headers.Authorization = `Bearer ${token}`;
        conf.headers['cem-key'] = window.location.origin.includes('localhost') ? "liCENcCCGpHUsEPHNhySYGXCnmhwzZ" : win["CEM_KEY"];

        return conf;
    }, (err) => {
        console.log("error in getting ", err);
    }
);

api.interceptors.response.use(async (response: any) => {
    return response;
}, async (error: any) => {
    if (!!win["errorPageURL"]) {
        document.location.href = win["errorPageURL"];
    }
    return error;
}
);

const sendEmailRequest = async (data: any) => {
    const baseUrl = win["base_api_url"]; //"https://apisit.mobily.com.sa/api" 
    const url = `${baseUrl}/utility/v1/notification`;

    return api.put(url, data)
}

export { sendEmailRequest };